<script setup lang="ts">
import { computed } from "vue";

import type { SightlineBoardCell } from "@/backend/natsstubs/sightline/models";
import { boardIcon } from "@/model/baseTypes";
import { useBoardsStore } from "@/store/boards";

import SightlineTruncatedText from "./SightlineTruncatedText.vue";

const props = defineProps<{ cell: SightlineBoardCell }>();

const boardsStore = useBoardsStore();

// the icon needs the board's type, which is not on the wire; the raw map
// avoids boardById's fabricated stub + Sentry report for unknown ids
const board = computed(() => boardsStore.boards[props.cell.id]);
</script>

<template>
  <SightlineTruncatedText :text="cell.label" :icon="board ? boardIcon(board.type) : undefined" />
</template>
